import { createFileRoute } from "@tanstack/react-router"

import { routeGuard } from "@/lib/routing/beforeLoad"

export const Route = createFileRoute("/_authlayout/_sidebar/resources/")({
  beforeLoad: async ({ context }) => {
    await routeGuard(context)
  },
  head: () => ({
    meta: [
      {
        title: "Resources | Arduino Cloud"
      }
    ]
  })
})
